import {Injectable} from '@angular/core';
import {environment} from '../../../environments/environment';
import {Helper} from '../../helpers/helper.service';
import {HttpClient, HttpParams, HttpResponse} from '@angular/common/http';
import {map, catchError} from 'rxjs/operators';
import {PackagingLabel} from '../Models/PackagingLabel';

@Injectable()
export class PackagingLabelService {
  constructor(private helper: Helper, private http: HttpClient) {
  }

  public getPackagingLabel(gridData = new HttpParams(), params = new HttpParams(), scope = 'backoffice') {
    return this.http.get<any>(environment.apiUrl + '/' + scope + '/packaging-label/?' + gridData.toString())
      .pipe(catchError(res => this.helper.catchError(res)));
  }

  public createPackagingLabel(packagingLabel: PackagingLabel) {
    return this.http.post(environment.apiUrl + '/backoffice/packaging-label/', packagingLabel)
      .pipe(catchError(res => this.helper.catchError(res)));
  }

  public getPackagingLabelPdf(path, filename) {
    return this.http.get(environment.apiUrl + '/download?path=' + path + '&filename=' + filename, {
      responseType: 'arraybuffer' as 'json',
      observe: 'response'
    }).pipe(
      map((resp: HttpResponse<ArrayBuffer>) => this.helper.fileDownloadMap(resp)),
      catchError(res => this.helper.catchError(res))
    );
  }
}
